// extracted by mini-css-extract-plugin
export default {"container":"styles_container__VYJIW","bodyWrapper":"styles_bodyWrapper__aoEOs","agentSignatureBodyWrapper":"styles_agentSignatureBodyWrapper__qEV5c"};